export const MARGIN = { top: 40, right: 16, bottom: 70, left: 40 };

export const CHART_SIZE = { width: 320, height: 220 };
